<script setup>
import {computed, onMounted, ref} from "vue";

import {useStore} from "vuex";
import CardElement from "@/components/billing/partials/CardElement.vue";
import StripeInfo from "@/components/billing/partials/StripeInfo.vue";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";

const store = useStore();

const props = defineProps({
  cardHolderName: {
    required: true,
    type: String,
  },
  showNotice: {
    required: false,
    type: Boolean,
    default: true,
  },
});

const currency = ref(null);
const errors = ref({});

const currencies = {
  'GBP': '£ (GBP)',
  'USD': '$ (USD)'
};

const stripe = computed(() => store.getters['billing/stripe']);

const name = computed({
  get(){
    return store.getters['billing/cardHolderName'];
  },
  set(value) {
    store.dispatch('billing/setCardHolderName', { name: value });
  },
});

const requiredFieldsSelected = async() => {
  if (!currency.value) {
    errors.value.currency = { message: 'Please fill the field currency' };
    return false;
  }

  return true;
}

onMounted(async () => {
  name.value = props.cardHolderName;
  await store.dispatch('billing/setupStripe', {});
});

defineExpose({
  currency,
  requiredFieldsSelected
});
</script>

<template>
  <div
    class="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-text-center tw-w-10/12 tw-mx-auto tw-py-6 tw-min-h-[680px]"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-6 tw-gap-8 tw-max-w-[760px] tw-w-3/4">
      <div class="tw-flex tw-flex-col">
        <h1 class="tw-text-4xl tw-font-bold">
          Add Card Details
        </h1>
      </div>

      <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
        <label
          for="card"
          class="tw-self-start tw-text-lg tw-text-grey-dark"
        >
          Card Number:
        </label>
        <CardElement
          v-if="stripe"
          ref="card"
          :show-notice="showNotice"
          :text-center="false"
          class="tw-text-left [&>*:first-child]:tw-rounded-lg [&>*:first-child]:tw-border [&>*:first-child]:tw-border-neutral-900 [&>*:first-child]:tw-px-6 [&>*:first-child]:tw-py-3"
        />
      </div>

      <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
        <label
          for="currency"
          class="tw-self-start tw-text-lg tw-text-grey-dark"
        >
          Currency:
        </label>
        <CustomMultiselect
          id="currency"
          v-model="currency"
          class="tw-text-left"
          :close-on-select="true"
          :options="currencies"
          :can-deselect="false"
          :validation-errors="errors.currency"
        />
      </div>

      <slot name="buttons" />
    </div>

    <div>
      <StripeInfo />
    </div>
  </div>
</template>
